(ns app.subs
  (:require
   [re-frame.core :as re-frame]
   [app.events :as events]
   [app.dashboard.events :as wevents]
   [re-posh.core :as re-posh]))

(re-posh/reg-sub
 ::workspace-ids
 (fn [_ _]
   {:type :query
    :query '[:find  ?e
             :where [?e :app/type :type/workspaces]]}))

(re-posh/reg-sub
 ::workspace-data
 :<- [::workspace-ids]
 (fn [workspace-id _]
   {:type    :pull
    :pattern '[*]
    :id      (first (first workspace-id))}))

(defn no-selected-workspace? [selected-workspace-data]
  (or (nil? (:selected-workspace/id selected-workspace-data)) (= (:selected-workspace/id selected-workspace-data) "")))

(defn workspace-exists? [workspace-data]
  (count (:workspace/data  workspace-data)))

(defn first-workspace [workspace-data]
  (first (:workspace/data workspace-data)))

(defn navigate-to-first-workspace! [workspace-data]
  {(re-frame/dispatch [::events/navigate
                       [:dashboard-view :id (:tenant_id (first-workspace workspace-data))]])
   (re-posh/dispatch [::wevents/add-selected-workspace
                      {:selected-workspace/id (:tenant_id (first-workspace workspace-data))
                       :selected-workspace/name (:name (first-workspace workspace-data))}])})

(defn navigate-to-new-workspace! []
  (re-frame/dispatch [::events/navigate [:new-workspace]]))

(re-frame/reg-sub
 ::get-workspace-data
 :<- [::workspace-data]
 :<- [::selected-workspace-data]
 (fn [[workspace-data selected-workspace-data] [_]]
   (when (no-selected-workspace? selected-workspace-data)
     (when (> (workspace-exists? workspace-data) 0)
       (navigate-to-first-workspace! workspace-data)))
   (:workspace/data workspace-data)))

(re-posh/reg-sub
 ::selected-workspace-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?wid
             :where [?wid :app/type :type/selected-workspace]]}))

(re-posh/reg-sub
 ::deleted-selected-workspace-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?wid
             :where [?wid :app/type :type/deleted-selected-workspace]]}))

(re-posh/reg-sub
 ::selected-workspace-data
 :<- [::selected-workspace-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :selected-workspace/id :selected-workspace/name :selected-workspace/folders]
    :id        (ffirst id)}))

(re-posh/reg-sub
 ::deleted-selected-workspace-data
 :<- [::deleted-selected-workspace-id]
 (fn [id _] 
   {:type    :pull
    :pattern '[:db/id :deleted-selected-workspace/assets]
    :id        8})) 


(re-frame/reg-sub
 ::selected-workspace-name
 :<- [::selected-workspace-data]
 :<- [::workspace-data]
 (fn [[workspace-id workspaces] [_]]
   (->> (:workspace/data workspaces)
        (some #(when (= (:tenant_id %) (:selected-workspace/id workspace-id))
                 (:name %))))))

(re-posh/reg-sub
 ::user-token
 (fn [_ _]
   {:type :query
    :query '[:find  ?wid
             :where [?wid :app/type :type/user]]}))

(re-posh/reg-sub
 ::user-token-id
 :<- [::user-token]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :user/token]
    :id        (ffirst id)}))

(re-posh/reg-sub
 ::user-email
 :<- [::user-token]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :user/email]
    :id        (ffirst id)}))

(re-posh/reg-sub
 ::user-name
 :<- [::user-token]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :user/name :user/profile-pic :user/email]
    :id        (ffirst id)}))

(re-posh/reg-sub
 ::login-error-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?wid
             :where [?wid :app/type :type/error]]}))

(re-posh/reg-sub
 ::login-error
 :<- [::login-error-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :error/value :error/show]
    :id       (ffirst id)}))

(re-posh/reg-sub
 ::selected-folder-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?fid
             :where [?fid :app/type :type/selected-folder]]}))

(re-posh/reg-sub
 ::restored-folder-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?fid
             :where [?fid :app/type :type/restored-folder]]}))


(re-posh/reg-sub
 ::deleted-selected-folder-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?fid
             :where [?fid :app/type :type/deleted-selected-folder]]}))

(re-posh/reg-sub
 ::selected-folder-data
 :<- [::selected-folder-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :selected-folder/id :selected-folder/name :selected-folder/order :selected-folder/new :selected-folder/projects :selected-folder/forms]
    :id       (ffirst id)}))

(re-posh/reg-sub
 ::restored-folder-data
 :<- [::restored-folder-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :restored-folder/id]
    :id       14}))


(re-posh/reg-sub
 ::folder-status-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?fid
             :where [?fid :app/type :type/folder-status]]}))

(re-posh/reg-sub
 ::get-folder-status
 :<- [::folder-status-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :folder-status/status]
    :id       13}))

(re-posh/reg-sub
 ::deleted-selected-folder-data
 :<- [::deleted-selected-folder-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :deleted-selected-folder/id :deleted-selected-folder/name :deleted-selected-folder/projects :deleted-selected-folder/forms]
    :id       12}))

(re-posh/reg-sub
 ::recent-updated-products-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?id
             :where [?id :app/type :type/statistics]]}))

(re-posh/reg-sub
 ::recent-updated-products
 :<- [::recent-updated-products-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:statistics/recent-products  :statistics/statistics-data :statistics/statistics-folder-data]
    :id       9}))

(re-frame/reg-sub
 ::selected-folder-name
 :<- [::selected-folder-data]
 :<- [::selected-workspace-data]
 (fn [[folder-id workspace-data] [_]]
   (->> (:selected-workspace/folders workspace-data)
        (some #(when (= (:workspace_id %) (:selected-folder/id folder-id))
                 (:name %))))))

(re-frame/reg-sub
 ::is-selected-folder-deleted?
 :<- [::selected-folder-data]
 :<- [::selected-workspace-data]
 (fn [[folder-id workspace-data] [_]]
   (->> (:selected-workspace/folders workspace-data)
        (some #(when (= (:workspace_id %) (:selected-folder/id folder-id))
                 (:workspace_id %))))))

(re-frame/reg-sub
 ::deleted-selected-folder-name
 :<- [::deleted-selected-folder-data]
 :<- [::selected-workspace-data]
 (fn [[folder-id workspace-data] [_]]
   (->> (:deleted-selected-workspace/folders workspace-data)
        (some #(when (= (:workspace_id %) (:deleted-selected-folder/id folder-id))
                 (:name %))))))

(re-frame/reg-sub
 ::selected-folder-index
 :<- [::selected-folder-data]
 :<- [::selected-workspace-data]
 (fn [[folder-id workspace-data] [_]]
   (if (some? (:selected-workspace/folders workspace-data))
     (.indexOf (:selected-workspace/folders workspace-data) (->> (:selected-workspace/folders workspace-data)
                                                                 (some #(when (= (:workspace_id %) (:selected-folder/id folder-id))
                                                                          %))))
     0)))

(re-frame/reg-sub
 ::deleted-selected-folder-index
 :<- [::deleted-selected-folder-data]
 :<- [::selected-workspace-data]
 (fn [[folder-id workspace-data] [_]]
   (if (some? (:deleted-selected-workspace/folders workspace-data))
     (.indexOf (:deleted-selected-workspace/folders workspace-data) (->> (:deleted-selected-workspace/folders workspace-data)
                                                                 (some #(when (= (:workspace_id %) (:deleted-selected-folder/id folder-id))
                                                                          %))))
     0)))

(re-posh/reg-sub
 ::last-action-folder-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?fid
             :where [?fid :app/type :type/last-action]]}))

(re-posh/reg-sub
 ::last-action-folder-data
 :<- [::last-action-folder-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :last-action/id :last-action/name]
    :id       (ffirst id)}))

(re-posh/reg-sub
 ::workspace
 (fn [_ [_ id]]
   {:type    :pull
    :pattern '[:workspace/data]
    :id      (int id)}))

(re-frame/reg-sub
 ::active-panel
 (fn [db _]
   (get-in db [:route :panel])))

(re-frame/reg-sub
 ::route-params
 (fn [db _]
   (get-in db [:route  :route-params])))
